import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Modal, Button, ButtonToolbar} from 'react-bootstrap'
import {infoStatus} from '../../core/redux/status'
import {replace} from '../../core/extract'
import LoaderButton from '../../core/components/LoaderButton'
import {DEFAULT_CONTACT_QUERY, queryContactStream} from '../../provider/actions'
import {sendDissociateActivityFromOpeningTicketPurposeAction, loadOpeningTicketPurposeRef} from '../actions'
import i18n from '../i18n'
import style from './DissociateActivityFromOpeningTicketPurposeModal.less'

class DissociateActivityFromOpeningTicketPurposeModal extends Component {
    static propTypes = {
        openingTicketPurpose: PropTypes.object.isRequired,
        activity: PropTypes.object.isRequired
    }

    componentWillMount() {
        const {dispatch, openingTicketPurpose, activity, company} = this.props
        dispatch(queryContactStream({...DEFAULT_CONTACT_QUERY, openingTicketPurposeUids: openingTicketPurpose.uid, activityUids: activity.uid, companyUid: company.uid, range: {offset: 0, limit: 999}}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openingTicketPurpose != this.props.openingTicketPurpose
            || nextProps.activity != this.props.activity
            || nextProps.company != this.props.company) {
            const {dispatch, openingTicketPurpose, activity, company} = nextProps
            dispatch(queryContactStream({...DEFAULT_CONTACT_QUERY, openingTicketPurposeUids: openingTicketPurpose.uid, activityUids: activity.uid, companyUid: company.uid, range: {offset: 0, limit: 999}}))
        }
    }

    _sendAction() {
        const {dispatch, onHide, openingTicketPurpose, activity} = this.props

        return dispatch(sendDissociateActivityFromOpeningTicketPurposeAction(openingTicketPurpose.uid, activity.uid)).then((action) => {
            return action.providerContactUpdated > 0 && dispatch(infoStatus(replace(i18n.providerContactDissociatedFromOpeningTicketPurpose, {count: action.providerContactUpdated})))
        }).then(() => {
            return dispatch(loadOpeningTicketPurposeRef())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, openingTicketPurpose, activity, providerContactStream, company, onHide, ...others} = this.props

        const providerContactElement = (providerContact) => (
            <li
                key={providerContact.uid}>
                <p>{[providerContact.name.firstName, providerContact.name.lastName, providerContact.name.value].filter((v) => v).join(' ')}</p>
            </li>
        )

        return (
            <Modal
                className='modal-danger'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.dissociateActivity}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.text}>
                        {i18n.dissociateActivityText.map((text, index) => (
                            <p key={index}>{replace(text, {...activity, count: providerContactStream.length || null})}</p>
                        ))}
                    </div>
                    {providerContactStream.length > 0 && (
                        <Row>
                            <Col sm={6}>
                                <ul className={style.providerContactGroup}>
                                    {providerContactStream.slice(0, providerContactStream.length / 2 + 1).map(providerContactElement)}
                                </ul>
                            </Col>
                            <Col sm={6}>
                                <ul className={style.providerContactGroup}>
                                    {providerContactStream.slice(providerContactStream.length / 2 + 1, providerContactStream.length).map(providerContactElement)}
                                </ul>
                            </Col>
                        </Row>
                    )}
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='danger'
                            bsSize='large'
                            onClick={() => this._sendAction()}>
                            {i18n.dissociate}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

DissociateActivityFromOpeningTicketPurposeModal = connect((state) => ({
    providerContactStream: state.provider.contact.stream,
    company: state.company.company
}))(DissociateActivityFromOpeningTicketPurposeModal)

export default DissociateActivityFromOpeningTicketPurposeModal


// WEBPACK FOOTER //
// ./lib/reference/components/DissociateActivityFromOpeningTicketPurposeModal.js